import React from 'react'
import { Link } from 'react-router-dom'
import FeatureCard from '../components/FeatureCard'
import '../styles/landing.css'

const featureGroups = [
  {
    category: '🤖 Inteligencia Artificial',
    color: 'var(--gold-light)',
    items: [
      { icon: <img src="/icons/ai.png" alt="IA" style={{ width: '56px' }} />, title: 'Vortex IA', description: 'Asistente digital preentrenado con terminología de tu institución para resolver tus dudas al instante.' },
      { icon: <img src="/icons/book.png" alt="Docs" style={{ width: '56px' }} />, title: 'Vortex Docs', description: 'Resúmenes y cuestionarios de tus archivos en segundos con tecnologías de vanguardia.' },
      { icon: <img src="/icons/robot.png" alt="Generador" style={{ width: '56px' }} />, title: 'Generador de Quizz', description: 'Sube PDF, TXT o DOCX y genera práctica personalizada para dominar tus temas.' },
      { icon: <img src="/icons/listen.png" alt="Texto a Audio" style={{ width: '56px' }} />, title: 'Vortex Audio', description: 'Todos los temas de tu temario en audios y la opción de generar los tuyos.' },
    ],
  },
  {
    category: '📚 Estrategias de Estudio',
    color: '#34d399',
    items: [
      { icon: '📇', title: 'Flashcards', description: 'Tarjetas de memoria con repetición espaciada y autoevaluación para fijar conceptos clave.' },
      { icon: '🛡️', title: 'Modo Guardia', description: 'Estudio auditivo pasivo: pregunta, pausa de reflexión y respuesta para aprender sin pantalla.' },
      { icon: '📊', title: 'Mapa de Debilidades', description: 'Diagnóstico visual por ley y materia con semáforo para enfocar tu estudio.' },
      { icon: '🗂️', title: 'Plan de Estudio', description: 'Organiza tu calendario y da seguimiento a tu avance rumbo al ascenso.' },
    ],
  },
  {
    category: '🎯 Evaluación y Preparación',
    color: '#fbbf24',
    items: [
      { icon: '🔭', title: 'Simulador de Examen', description: 'Formato de evaluación real con cronómetro y preguntas alineadas al temario de tu institución.' },
      { icon: '📋', title: 'Cuestionarios', description: 'Banco extenso de preguntas con retroalimentación inmediata para repasar todo el temario.' },
      { icon: '📖', title: 'Cursos de Actualización', description: 'Periodos de estudio estructurados con temarios, evaluaciones y material descargable en PDF.' },
      { icon: '🧭', title: 'Avance y Resultados', description: 'Mide tu progreso con estadísticas claras y celebra cada meta alcanzada.' },
    ],
  },
]

export default function Features() {
  return (
    <section id="features" className="section">
      <div className="container">
        <div className="text-center mb-2xl">
          <h2>Herramientas integradas en Vortex</h2>
          <p style={{ maxWidth: '700px', margin: '0 auto' }}>
            Todo lo que necesitas para estudiar, evaluarte y avanzar hacia ese ascenso en un solo lugar,
            elijas SEMAR, Guardia Nacional o SEDENA.
          </p>
        </div>

        {featureGroups.map((group) => (
          <div key={group.category} style={{ marginBottom: 'var(--spacing-2xl)' }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              marginBottom: 'var(--spacing-lg)'
            }}>
              <span style={{
                width: '34px',
                height: '34px',
                borderRadius: '10px',
                background: `${group.color}22`,
                border: `1px solid ${group.color}55`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.1rem',
                flexShrink: 0
              }}>
                {group.category.split(' ')[0]}
              </span>
              <h3 style={{
                margin: 0,
                fontSize: '1.4rem',
                fontWeight: '800',
                color: 'var(--text-primary)'
              }}>
                {group.category}
              </h3>
            </div>

            <div className="grid grid-4">
              {group.items.map((feature, index) => (
                <FeatureCard
                  key={index}
                  icon={feature.icon}
                  title={feature.title}
                  description={feature.description}
                />
              ))}
            </div>
          </div>
        ))}

        <div className="section-cta">
          <h3>¿Listo para tomar las cosas en serio?</h3>
          <p>
            Únete a cientos de compañeros que ya están usando Ascensos App Vortex y juntos alcancemos esa meta.
          </p>
          <div style={{ display: 'flex', gap: 'var(--spacing-md)', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/cursos" className="btn btn-primary">
              Explorar los Cursos
            </Link>
            <a href="#availability" className="btn btn-secondary">Descargar ahora</a>
          </div>
        </div>
      </div>
    </section>
  )
}
